import React, {useCallback, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {v4 as uuidv4} from 'uuid'
import {changeModalVisibility} from '../../../../setup/slices/ModalSlice'
import {client} from '../../../ApolloClient/client'
import {
  getActivityCallHistory,
  getActivityStatementsFromEmpty,
  getSalesPersonId,
} from '../../../helper/ActivityHelper'
import {CREATE_ACTIVITY_FROM_EMPTY, UPDATE_ACTIVITY_STATUS} from '../../../store/queries'
import '../../../styles/Modal.css'
import {GetBillTable, GetCustomerContactInfo} from '../../AnaVezne/apis/ApiCall'
import CallAgain from './modal-components/CallAgain'
import FuturePayment from './modal-components/FuturePayment'
import InstantPayment from './modal-components/InstantPayment'
import ModalBillTable from './modal-components/ModalBillTable'
import ModalPassedCalls from './modal-components/ModalPassedCalls'
import moment from 'moment'
import AuthService from '../../auth/redux/AuthService'

interface Props {
  customer: any
  activityInfo: any
}

const ModalCard: React.FC<Props> = ({customer, activityInfo}) => {
  const [activityForms, setActivityForms] = useState<string>('none')
  const [emptyActivity, setEmptyActivity] = useState<any>()
  const [formValues, setFormValues] = useState<any>()
  const [emptyActivityStatementCodes, setEmptyActivityStatementCodes] = useState<any>()
  const [callHistory, setCallHistory] = useState<any>()
  const [activityHistNumber, setActivityHistNumber] = useState<number>(5)
  const [bills, setBills] = useState<any>()
  const [selectedDebt, setSelectedDebt] = useState<number>(0.0)
  const [salesPersonId, setSalesPersonId] = useState<any>()
  const [email, setEmail] = useState<string>('')
  const [sms, setSms] = useState<string>('')
  const [primaryContactName, setPrimaryContactName] = useState<string>('')

  // const typeGuid = "b7e39044-ea50-49a7-94d4-96ea12f851f8"
  const typeGuid = '2978C75D-D89F-4EE4-8DA4-D82FA90F2605'
  const statusGuid = '4A61E63E-ABBA-40C2-9C0D-B4062B6B876A'

  const user = AuthService.GetCurrentUser()

  useEffect(() => {
    getSalesPersonId(setSalesPersonId, user.salesPersonGuid)
  }, [])

  useEffect(() => {
    getActivityCallHistory(
      activityHistNumber,
      typeGuid,
      client,
      setCallHistory,
      customer.CustomerId
    )
  }, [])

  useEffect(() => {
    getActivityCallHistory(
      activityHistNumber,
      typeGuid,
      client,
      setCallHistory,
      customer.CustomerId
    )
  }, [activityHistNumber])

  useEffect(() => {
    if (customer !== undefined) {
      GetBillTable(setBills, customer.Customerreference)
      GetCustomerContactInfo(customer.Customerreference, setEmail, setSms, setPrimaryContactName)
      console.log(customer)
    }
  }, [customer])

  const dispatch = useDispatch()

  useEffect(() => {
    getActivityStatementsFromEmpty(typeGuid, setEmptyActivity, client)
  }, [])

  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      dispatch(changeModalVisibility(false))
    }
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  let statementCodeArray: any[] = []
  useEffect(() => {
    if (emptyActivity !== undefined) {
      const activityStatements = emptyActivity?.activityStatements
      activityStatements?.map((element: {statementCode: any}) =>
        statementCodeArray.push(element.statementCode)
      )
      setEmptyActivityStatementCodes(statementCodeArray)
    }
  }, [emptyActivity])

  const composeEmptyActivityObj = (customer: any) => {
    if (formValues[0] !== undefined) {
      let emptyActivityStatementList = []

      for (let i = 0; i < emptyActivityStatementCodes.length; i++) {
        type ModelObject = {
          notes: string
          statementCode: string
          value: string
        }

        let object: ModelObject = {
          notes: '',
          statementCode: '',
          value: '',
        }

        if (emptyActivityStatementCodes[i] === 'Y1') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[0]
          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y2') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[1]

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y3') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[2]

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y4') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[3]

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y5') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[4].toString()

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y6') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[5]

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y7') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[6]

          emptyActivityStatementList.push(object)
        } else if (emptyActivityStatementCodes[i] === 'Y8') {
          object.notes = `Program Bilgileri ${emptyActivityStatementCodes[i]}`
          object.statementCode = emptyActivityStatementCodes[i]
          object.value = formValues[7]

          emptyActivityStatementList.push(object)
        }
      }

      let model = {
        activityTypeGuid: typeGuid,
        activityStatus: {
          guid: statusGuid,
        },
        notes: '',
        activityStatements: emptyActivityStatementList,
        planDateTime: moment(new Date()).format('YYYY-MM-DD') + ' ' + moment().format('HH:mm'),
        planEndDateTime:
          moment(new Date()).add(5, 'days').format('YYYY-MM-DD') + ' ' + moment().format('HH:mm'),
        customerGuid: customer.CustomerGuid,
      }
      console.log(model)
      return model
    } else {
      return 'error'
    }
  }

  const composeActivity = async (customer: any) => {
    let model = composeEmptyActivityObj(customer)

    if (model === 'error' || model === undefined) {
      console.log('model oluşturulamadı!!')
    } else {
      await client
        .mutate({
          mutation: CREATE_ACTIVITY_FROM_EMPTY,
          variables: {model},
        })
        .then((resp) => resp.data.createActivityFromEmptyActivity.activity)
        .then((activity) => ({guid: activity.guid, updateVersion: activity.updateVersion}))
        .then(async (model: {guid: any; updateVersion: any}) => {
          await client
            .mutate({
              mutation: UPDATE_ACTIVITY_STATUS,
              variables: {model},
            })
            .then(() => console.log('Görev Başarılı!'))
        })
        .catch((err: any) => {
          console.log('Hata Oluştu: ' + err)
        })
    }
  }

  return (
    <div className='custom-modal bd-example-modal-lg' id='tahsilat-modal'>
      <div className='modal-dialog modal-dialog-scrollable modal-lg' role='document'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2 className='modal-title' id='exampleModalLongTitle'>
              {customer.CustName}
            </h2>
            <button
              type='button'
              className=' btn btn-danger close w-30px h-30px p-0'
              onClick={() => dispatch(changeModalVisibility(false))}
            >
              <span className='fw-bolder fs-2'>&times;</span>
            </button>
          </div>
          <div className='modal-body'>
            <div className='row d-flex ps-10 justify-content-between'>
              <div className='col-6 me-10'>
                {' '}
                <span className='fw-bolder text-muted fs-5'> Tel:</span>{' '}
                <span className='fw-bolder fs-4'> {sms.slice(3)}</span>
              </div>
              <div className='col-4'>
                <span className='fw-bolder text-muted fs-5'> Yetkili: </span>
                <span className='fw-bolder fs-4'> {primaryContactName}</span>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ModalBillTable
                  bills={bills}
                  customer={customer}
                  selectedDebt={selectedDebt}
                  setSelectedDebt={setSelectedDebt}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ModalPassedCalls
                  callHistory={callHistory}
                  activityHistNumber={activityHistNumber}
                  setActivityHistNumber={setActivityHistNumber}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <div className='d-flex overflow-auto h-55px'>
                  <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap justify-content-evenly w-100 mt-4'>
                    {emptyActivity !== undefined &&
                      emptyActivity?.activityStatements[4].jsonValues.items.map(
                        (element: any, index: number) => (
                          <li
                            className={
                              `btn ` +
                              (activityForms === `list-${index}` ? 'btn-danger' : 'btn-secondary')
                            }
                            key={index}
                            style={{cursor: 'pointer'}}
                            onClick={(e) => setActivityForms(e.currentTarget.id)}
                            id={`list-${index}`}
                          >
                            <label
                              htmlFor={`${emptyActivity.activityStatements[4].statementCode}-${index}`}
                              style={{cursor: 'pointer'}}
                            >
                              {element.option}
                            </label>
                            <input
                              type='radio'
                              autoComplete='off'
                              className='btn-check'
                              value={index}
                              name={`${emptyActivity.activityStatements[0].statementCode}`}
                              id={`${emptyActivity.activityStatements[0].statementCode}-${index}`}
                            />
                          </li>
                        )
                      )}
                  </ul>
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-md-12 w-100 mt-10 justify-content-between'>
                {activityForms === 'none' ? null : activityForms === 'list-0' ? (
                  <InstantPayment
                    emptyActivity={emptyActivity}
                    setFormValues={setFormValues}
                    composeActivity={composeActivity}
                    setCallHistory={setCallHistory}
                    typeGuid={typeGuid}
                    selectedDebt={selectedDebt}
                    customer={customer}
                    sms={sms}
                    email={email}
                  />
                ) : activityForms === 'list-1' ? (
                  <FuturePayment
                    emptyActivity={emptyActivity}
                    setFormValues={setFormValues}
                    composeActivity={composeActivity}
                    setCallHistory={setCallHistory}
                    typeGuid={typeGuid}
                    selectedDebt={selectedDebt}
                    customer={customer}
                    sms={sms}
                    email={email}
                  />
                ) : activityForms === 'list-2' ? (
                  <CallAgain
                    emptyActivity={emptyActivity}
                    setFormValues={setFormValues}
                    composeActivity={composeActivity}
                    setCallHistory={setCallHistory}
                    typeGuid={typeGuid}
                    customer={customer}
                  />
                ) : null}
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-danger'
              data-dismiss='modal'
              onClick={() => dispatch(changeModalVisibility(false))}
            >
              İptal
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCard
